import React, { useState, useMemo } from 'react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css' // Import css
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import Weight from '../ui/Weight.js';
import Field from '../ui/Field.js';
import Box from '../ui/Box.js';
import ConfirmUI from '../ui/Confirm.js';
import HarvestForm from './interface.js';
import api from '../../api/index.js';

import { callback } from '../../helpers.js';


export default (props) => {

	const [interfaceOpen, setInterfaceOpen] = useState(false);

	let fields = [];
	for(let i=0; i < props.fields.length; i++) {
		fields.push(<li key={i} className="harvest-field">{props.fields[i].FarmName}: Field {props.fields[i].FieldNumber} <Weight value={props.fields[i].Weight} precision="0" /></li>);
	}


	const deleteClick = () => {
		confirmAlert({
			title: 'Permanently delete this harvest record: '  + props.HarvestID,
			customUI: ConfirmUI(
				()=>{props.onDelete(props.HarvestID)},
				<div><p className="red"><em><strong>This is not a safe action.</strong></em></p><p>Avoid this unless you've entered a harvest record by mistake. Are you sure you want to do this?</p></div>
			),
		});
	}


	const onSaved = (e) => {
		callback(props.refresh, [e]);
		setInterfaceOpen(false);
	}


	const massage = (data) => {
		let rows = [];
		for(let i=0; i < data.length; i++)
			rows.push({'field': data[i].FieldID, 'weight': data[i].Weight});
		return rows;
	}


	return <Box className={"harvest-record " + ((props.invoiceCount[props.InvoiceNumber] || 1) > 1 ? ' error duplicate' : '')} title={"Harvest record " + props.HarvestID} options={[
		{
			label: <span><FontAwesomeIcon icon={faEdit} className="editIcon" /> Modify this harvest record</span>,
			callback: ()=>{setInterfaceOpen(true);}
		},
		{
			label: <span><FontAwesomeIcon icon={faExclamationTriangle} className="exclaimIcon" /> <small>Actually <strong>delete</strong> this harvest record from the system</small></span>,
			callback: deleteClick
		},
	]}>
		<p>Date: {props.Date}</p>
		<p>Invoice number: {props.InvoiceNumber}</p>
		<p>Processor: {props.ProcessorName} <br />{props.GradeName} { props.QuotedPrice && '(quoted at $' + parseFloat(props.QuotedPrice).moneyFormat() + ')' }</p>
		<ul>{fields}</ul>
		<Box modal={true} isOpen={interfaceOpen} onRequestClose={(e)=>{setInterfaceOpen(false)}} title={"Harvest record " + props.HarvestID + " interface"}>
			<HarvestForm recordId={props.HarvestID} date={api.date(props.Date)} quotedPrice={props.QuotedPrice} invoice={props.InvoiceNumber} processor={props.ProcessorID} grade={props.Grade} rows={massage(props.fields)} onSaved={onSaved}/>
		</Box>
	</Box>

}